import { call, fork, select, takeLatest } from 'redux-saga/effects';

import { fetchEfectoresByPractice, addPracticeEfector, deletePracticeEfector, updatePracticeEfector } from '../api';
import { practiceEfectoresActions } from './actions';

import { getPracticeEfectoresById } from './selectors';

export function* loadEfectores({payload}) {
  const { practiceEfectoresId, filters } = payload;

  const practiceEfectores = yield select(getPracticeEfectoresById, practiceEfectoresId);

  if ( practiceEfectores ) {
    //verificar el tiempo que paso desde que se obtuvo los datos del efector, si paso mas de 10 minutos se vuelve a pedir
    const current_date = new Date();
    const interval = current_date.getTime() - practiceEfectores.created_at.getTime();
    const elapsed_time =  Math.round(interval/(1000 * 60 * 10));

    if ( practiceEfectores.isNew || elapsed_time ){
      yield call(fetchEfectoresByPractice,  practiceEfectoresId, filters);
    }
  }

}

export function* addEfector({payload}) {
  const { data, practiceEfectoresId } = payload;
  yield call(addPracticeEfector, practiceEfectoresId, data);
}

export function* deleteEfector({payload}) {
  const { practiceEfectoresId, data } = payload;
  yield call(deletePracticeEfector, practiceEfectoresId, data);
}

export function* updateEfector({payload}) {
  const { practiceEfectoresId, data } = payload;
  
  yield call(updatePracticeEfector, practiceEfectoresId, data);
}


//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadEfectores() {
  yield takeLatest(practiceEfectoresActions.LOAD_PRACTICE_EFECTORES, loadEfectores);
}

export function* watchAddEfector() {
  yield takeLatest(practiceEfectoresActions.ADD_PRACTICE_EFECTOR, addEfector);
}

export function* watchDeleteEfector() {
  yield takeLatest(practiceEfectoresActions.DELETE_PRACTICE_EFECTOR, deleteEfector);
}

export function* watchUpdatePracticeEfector() {
  yield takeLatest(practiceEfectoresActions.UPDATE_PRACTICE_EFECTOR, updateEfector);
}



//=====================================
//  ROOT
//-------------------------------------

export const practiceEfectoresSagas = [
  fork(watchLoadEfectores),
  fork(watchAddEfector),
  fork(watchDeleteEfector),
  fork(watchUpdatePracticeEfector),
];
